/**
 * Global Axios Interceptor Setup
 * This file sets up interceptors on the default axios instance
 * so that all axios calls throughout the app will have these behaviors.
 */

import axios from 'axios';
import sessionManager from './sessionManager';
import { getActiveClientId, clearActiveClient } from './clientWorkspace';

// Response interceptor - handle 401 errors globally
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token is invalid or expired
            console.log('Received 401 - clearing auth and redirecting to login');

            // Clean up session
            sessionManager.cleanup();
            
            // Clear auth data
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('tokenExpiry');
            clearActiveClient();

            // Redirect to login page
            // Using window.location to ensure full page reload and state reset
            if (window.location.pathname !== '/login') {
                window.location.href = '/login?session_expired=true';
            }
        }
        return Promise.reject(error);
    }
);

// Request interceptor - add auth token to all requests (optional, for convenience)
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token && !config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        const activeClientId = getActiveClientId();
        if (activeClientId && !config.headers['x-client-user-id']) {
            config.headers['x-client-user-id'] = activeClientId;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

console.log('Axios interceptors configured for global auth handling');
